import React, { useCallback, useState } from 'react'
import styles from './styles.module.scss'
import { ShieldCheck } from 'lucide-react'
import SecureText from '../SecureText'
import Orb from '../Orb'
import SecureInfoModal from '../SecureInfoModal'

// Pressing the pill opens a card explaining the secure connection
const SSLBadge: React.FC = () => {
    const [infoOpen, setInfoOpen] = useState(false)
    // Stable, so the modal's open-state setup (focus, Esc, scroll lock) runs once
    const closeInfo = useCallback(() => setInfoOpen(false), [])

    return (
        <>
            <button
                type="button"
                className={styles.sslBadge}
                onClick={() => setInfoOpen(true)}
                aria-haspopup="dialog"
            >
                {/* Animated orb; browsers that can't draw it, and reduced motion, get the shield instead */}
                <Orb size={14} className={styles.pillOrb} />
                <ShieldCheck className={styles.shieldIcon} />
                <div className={styles.textContent}>
                    <SecureText />
                </div>
            </button>
            <SecureInfoModal open={infoOpen} onClose={closeInfo} />
        </>
    )
}

export default SSLBadge
